import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NotificationsStoreModule } from './store/module';

@NgModule({
  imports: [MatSnackBarModule, NotificationsStoreModule],
})
export class NotificationsModule {}
